import { z } from 'zod';
import { $CandidateActivitySphere } from './CandidateActivitySphere';
import { $CandidateCity } from './CandidateCity';
import { $CandidateEconomicActivity } from './CandidateEconomicActivity';
import { $CandidateUser } from './CandidateUser';

export const $CandidateCompany = z.object({
  id: z.number(),
  name: z.string(),
  type: z.enum([
    'association_ong',
    'auto_entrepreneur',
    'cooperative',
    'sole_proprietorship',
    'public_limited_company',
    'limited_liability_company',
    'limited_partnership',
    'partnership',
  ]),
  nif: z.string(),
  regionId: z.number().nullable(),
  description: z.string(),
  isActive: z.boolean(),
  isSurfer: z.boolean(),
  nccVerified: z.boolean().nullable(),
  rating: z.number().nullable(),
  level: z.enum(['iron', 'bronze', 'silver', 'gold', 'platinum']).nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  manager: $CandidateUser,
  city: $CandidateCity,
  activitySpheres: z.array($CandidateActivitySphere),
  economicActivities: z.array($CandidateEconomicActivity),
});
